'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _helpersApiClient = require('../../helpers/ApiClient');

var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);

var _Component = require('../Component');

var _Component2 = _interopRequireDefault(_Component);

var _Lookup = require('./Lookup');

var _Lookup2 = _interopRequireDefault(_Lookup);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = {
	_$ClientLookup: {
		displayName: 'ClientLookup'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var ClientLookup = (function (_Component) {
	_inherits(ClientLookup, _Component);

	function ClientLookup() {
		_classCallCheck(this, _ClientLookup);

		_Component.apply(this, arguments);
	}

	ClientLookup.prototype.api = function api(q, page) {
		var client = new _helpersApiClient2['default']();
		return client.call('client.lookup', { q: q, page: page });
	};

	ClientLookup.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(_Lookup2['default'], _extends({ query: function (q, page) {
				return _this.api(q, page);
			} }, this.props));
	};

	var _ClientLookup = ClientLookup;
	ClientLookup = _wrapComponent('_$ClientLookup')(ClientLookup) || ClientLookup;
	return ClientLookup;
})(_Component2['default']);

exports['default'] = ClientLookup;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Form/ClientLookup.js
 ** module id = 89
 ** module chunks = 2
 **/